/**
 * The player's colours: the app's watch player (frontend-app `WatchControls`,
 * drawn by FabroLabs/story-player), so a story looks the same in the studio, in
 * an exported zip and in the app — dark teal glass, mint for the one thing to
 * press.
 *
 * Plain strings rather than CSS variables: the HUD, the control bar and the
 * subtitle band each inject their own `<style>` text, and an exported
 * `player.html` has none of the SPA's design tokens to lean on.
 */
export const THEME = {
  /** The letterbox and every full-screen sheet behind the picture. */
  shell: '#0e1416',
  ink: '#091012',
  inkSoft: '#142020',
  /** Mint: the one thing to press. */
  accent: '#92e3c4',
  accentSoft: '#53d7ac',
  /** Glyphs and words on an accent fill. */
  onAccent: '#0b2b1e',
  /** The control bar's glyphs and time. */
  dockText: '#f5fbf7',
  text: '#eaf3f0',
  textDim: '#9fb3ae',
  /** The seek line: rail, played part, thumb. */
  rail: '#49756a',
  progress: '#13e9b0',
  thumb: '#b3f2d8',
  /** A control under the pointer. */
  hover: 'rgb(146 227 196 / 0.12)',
  /** The CC box while subtitles are on. */
  ccOn: '#ecf8f2',
  ccOnText: '#092623',
  line: 'rgba(255,255,255,0.12)',
  /** The subtitle plate (and the on-screen confirmation, which reads like one). */
  caption: 'rgb(7 26 24 / 0.9)',
  /** Ghost buttons over the picture. */
  glass: 'rgba(6,16,18,0.55)',
  glassLine: 'rgba(255,255,255,0.28)',
  /** Menus and sheets that sit on the picture. */
  sheet: 'rgb(7 26 24 / 0.96)',
  /** The app's type: rounded system faces, no web font to wait for. */
  font: 'ui-rounded, "SF Pro Rounded", "Segoe UI", system-ui, sans-serif',
} as const
